import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {BackButtonAction} from '../../../core/utils/string.util';
import Find_product_size from '../../../assets/json/Find_product_size.json';
import Lottie from 'react-lottie';

import {
  setAppBarTitle,
  setBackNavAction,
  setBackNavEnabled,
} from '../../../redux/globalSlice';
import {
  mmrpResponse,
  orderResponse,
  addProductResponse,
  resetMMRPState,
  addProduct,
  resetAddproductState,
} from '../../../redux/orderSlice';
import {
  getAccessToken,
  getStoreInformation,
} from '../../../core/localstorage-data';
import SizeCard from '../../../components/card/Card';
import {MMRPResponse} from '../../../lib/order-types';

// type PaymentProps = {
//   children?: React.ReactNode;
//   className?: string;
//   onViewDetailsClicked: () => void;
//   onProceed: () => void;
//   totalAmount?: number;
// };

const MatchPrice = () => {
  const [productPrice, setProductPrice] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [mmrpState, setMmrpState] = useState<MMRPResponse | null>(null);
  const navigate = useHistory();
  const dispatch = useAppDispatch();
  const mmrpResp = useAppSelector(mmrpResponse);
  const orderResp = useAppSelector(orderResponse);
  const addProductResp = useAppSelector(addProductResponse);
  const storeCode = `0${getStoreInformation().store_code}`;
  const [incorrectPrice, setIncorrectPrice] = useState(false);

  useEffect(() => {
    dispatch(setAppBarTitle('Match the price'));
    dispatch(setBackNavEnabled(true));
    dispatch(setBackNavAction(BackButtonAction.GO_BACK));

    return () => {
      // Clean up the subscription
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
      dispatch(setBackNavAction(undefined));
    };
  }, []);

  useEffect(() => {
    if (mmrpResp) {
      setMmrpState(mmrpResp);
    }
    dispatch(resetMMRPState());
  }, [mmrpResp]);

  useEffect(() => {
    if (addProductResp) {
      if (addProductResp.statusCode === '1045') {
        setIsValid(false);
        dispatch(resetAddproductState());
      } else {
        dispatch(resetMMRPState());
        const updatedMmrpPriceList = mmrpState?.priceList.filter(list => {
          return list.extSellPrice === Number(productPrice);
        });
        const updatedMMRP = {...mmrpState, priceList: updatedMmrpPriceList};
        navigate.push('/checkout', {
          updatedMMRP,
        });
      }
    }
  }, [addProductResp]);

  function handleChange(e: any) {
    const re = /^[0-9]*(\.[0-9]{0,2})?$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      setProductPrice(e.target.value);
    }
    if (e.target.value === '') {
      setIsValid(true);
    }
  }

  function handleSubmit() {
    const parameters = {
      accessToken: getAccessToken(),
      payload: {
        storeCode: storeCode,
        orderId: orderResp?.orderId,
        productId: mmrpState?.itemID,
        selectedPrice: Number(productPrice),
      },
    };
    dispatch(addProduct(parameters));
  }

  const infoMatchPrice = {
    loop: true,
    autoplay: true,
    animationData: Find_product_size,
    rendererSettings: {
      // preserveAspectRatio: "xMidYMid slice"
    },
  };
  return (
    <div className="flex flex-nowrap flex-col m-auto pt-4 px-6">
      <SizeCard classes="w-full rounded-lg bg-white">
        <div className="pt-8 ml-4 flex justify-between leading-3">
          <div>
            <span className="font-medium font-roboto">Max fashion</span>
            <div className="text-small mt-2">{mmrpState?.itemDesc}</div>
          </div>
        </div>
        <div className="pt-2 ml-4 flex justify-between leading-4">
          <div>
            <span className="text-small leading-1 text-left font-medium font-roboto text-black_zero"></span>
          </div>
          <div className=" text-right mr-4">
            <div>
              <span className="text-xs font-roboto min-w-min">
                Colour :<b> {mmrpState?.itemColour} </b>
              </span>
            </div>
            <div style={{minWidth: '100px'}}>
              <span className="text-xs font-roboto text-left">
                Size : <b> {mmrpState?.itemSize}</b>
              </span>
            </div>
          </div>
        </div>
        <div className=" ml-4 flex justify-between leading-3 pb-4 ">
          <div></div>
          <div className=" text-right mr-4"></div>
        </div>
      </SizeCard>
      <div className="mt-4 mb-6 text-center text-base font-roboto">
        <p>
          To help us give you the best price, please enter the price that is
          there on the label.
        </p>
      </div>
      <div>
        <div
          className={`font-roboto px-4 py-2 mb-1 bg-blue_four ${
            !isValid
              ? 'border-red_zero rounded-radius10 border-1 border-solid'
              : ''
          }`}>
          <div className="text-xxs font-extrabold">Product Price</div>
          <div className="flex">
            <div className="mr-2">{'\u20B9'}</div>
            <input
              className="focus:outline-none bg-blue_four"
              type="text"
              placeholder="00.00"
              value={productPrice}
              onChange={handleChange}
            />
          </div>
        </div>
        {!isValid && (
          <div className="text-xxs text-red_zero">
            *Incorrect entry! Please enter the price on the product label
          </div>
        )}
      </div>
      <div className="my-8 w-80 h-44">
        <Lottie options={infoMatchPrice} />
      </div>
      <div>
        <button
          className={`cursor-none-allowed text-white h-50 rounded-radius10 grid place-items-center focus:outline-none w-full text-center primary normal`}
          type="submit"
          onClick={handleSubmit}
          disabled={productPrice === ''}>
          <p className="font-bold font-roboto">Continue</p>
        </button>
      </div>
    </div>
  );
};

export default MatchPrice;
